import { styled } from '@mui/system';
import { Switch, Typography } from '@mui/material';
import { FC } from 'react';

const AllCommunicationContainer = styled('div')({
  padding: '32px 24px'
});

const AllCommunicationSectionStyled = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 16px',
  background: '#EBF3FA',
  borderRadius: '8px',
  height: '42px'
});

const DisplayText = styled(Typography)({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  color: '#000000'
});

const CustomSwitch = styled(Switch)({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#008A06'
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#2DE13F'
  }
});

interface AllCommunicationSectionProps {
  text: string;
  isChecked: boolean;
  onChange: (value: boolean) => void;
  className?: string;
}

const AllCommunicationSection: FC<AllCommunicationSectionProps> = (props) => {
  const { text, isChecked, onChange, className } = props;

  return (
    <AllCommunicationContainer className={className}>
      <AllCommunicationSectionStyled className="all-communication-section">
        <DisplayText className="all-communication-display-text" variant="body2">
          {text}
        </DisplayText>
        <CustomSwitch checked={isChecked} onChange={(e, checked) => onChange(checked)} />
      </AllCommunicationSectionStyled>
    </AllCommunicationContainer>
  );
};

export default AllCommunicationSection;
